const milestones = [
  {
    year: 'Founded',
    title: 'Company Established',
    description: 'Started as a family-owned business with a commitment to quality concrete pumping services in Otto, NC.',
  },
  {
    year: 'Growth',
    title: 'Service Expansion',
    description: 'Expanded services to include professional stone installation and custom masonry work.',
  },
  {
    year: 'Today',
    title: 'Regional Leader',
    description: 'Serving Western North Carolina, North Georgia, and Southwest South Carolina with excellence.',
  },
];

const values = [
  {
    icon: 'ri-focus-3-line',
    title: 'Precision',
    description: 'Every project executed with meticulous attention to detail and accuracy.',
  },
  {
    icon: 'ri-shield-star-line',
    title: 'Reliability',
    description: 'Dependable service you can count on for projects of any size.',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Customer First',
    description: 'Your satisfaction is our top priority from start to finish.',
  },
];

const CompanyStory = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-black mb-4">Our Journey</h2>
          <p className="text-lg text-gray-600">Building trust and quality, one project at a time</p>
        </div>

        <div className="relative mb-20">
          <div className="absolute left-1/2 top-0 bottom-0 w-1 bg-yellow-500 -translate-x-1/2 hidden lg:block"></div>

          <div className="space-y-12">
            {milestones.map((milestone, index) => (
              <div
                key={index}
                className={`flex flex-col lg:flex-row gap-8 items-center ${
                  index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                }`}
              >
                <div className="flex-1 lg:text-right">
                  {index % 2 === 0 && (
                    <div className="bg-white p-8 rounded-2xl shadow-lg">
                      <div className="text-yellow-500 text-2xl font-bold mb-2">
                        {milestone.year}
                      </div>
                      <h3 className="text-2xl font-bold text-black mb-3">
                        {milestone.title}
                      </h3>
                      <p className="text-gray-600 leading-relaxed">
                        {milestone.description}
                      </p>
                    </div>
                  )}
                </div>

                <div className="relative z-10">
                  <div className="w-16 h-16 bg-yellow-500 rounded-full flex items-center justify-center border-4 border-white shadow-lg">
                    <i className="ri-checkbox-circle-fill text-black text-2xl"></i>
                  </div>
                </div>

                <div className="flex-1">
                  {index % 2 !== 0 && (
                    <div className="bg-white p-8 rounded-2xl shadow-lg">
                      <div className="text-yellow-500 text-2xl font-bold mb-2">
                        {milestone.year}
                      </div>
                      <h3 className="text-2xl font-bold text-black mb-3">
                        {milestone.title}
                      </h3>
                      <p className="text-gray-600 leading-relaxed">
                        {milestone.description}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-black mb-4">Our Core Values</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-2xl shadow-lg text-center hover:shadow-xl transition-all"
            >
              <div className="w-20 h-20 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className={`${value.icon} text-4xl text-black`}></i>
              </div>
              <h3 className="text-2xl font-bold text-black mb-3">{value.title}</h3>
              <p className="text-gray-600 leading-relaxed">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CompanyStory;